import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colorsPalette } from '../../../../theme';

export const useStyles = (wrapperWidth) =>
  makeStyles(() =>
    createStyles({
      popper: {
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: 20,
        boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.4)',
        marginTop: -45,
        zIndex: 2,
        minWidth: wrapperWidth,
      },
      chevronIcon: {
        fill: colorsPalette.blue,
      },
    }),
  );
